<div class="lg:w-[400px] w-[90%] h-11 rounded-md relative shadow">
      <input type="text" placeholder="جستجو در نقشه" [formControl]="searchControl" (focus)="showResults = true"
            class="searchBoxInput w-full h-full px-4 rounded-lg outline-none border border-b-2 border-solid border-transparent focus:border-blue-500 ">
      <div *ngIf="showResults"
            class="searchSuggestBox absolute w-full max-h-[500px] bg-white overflow-y-auto mt-2 rounded-lg">
            <div *ngFor="let hotel of (dataSource | filter: 'CardData.HotelName' : filterText)"
                  (click)="selectItem(hotel.CardData)"
                  class="flex bg-white rounded-lg p-4 hover:bg-blue-500 hover:text-white transition-all duration-300 cursor-pointer">
                  {{hotel.CardData.HotelName}}
            </div>

      </div>
</div>